import { DateTime } from 'luxon';
import { sortByDateTimeFunc } from '../DataTable/utils';

const getColumns = () => [
  {
    id: 'drone',
    Header: 'Drone',
    accessor: 'drone',
  },
  {
      id: 'purpose',
      Header: 'Purpose',
      accessor: 'purpose',
  },
  {
      id: 'startPosition',
      Header: 'Start position',
      disableSortBy: true,
      accessor: 'start_position',
  },
  {
      id: 'endPosition',
      Header: 'Landing position',
      accessor: 'end_position',
      disableSortBy: true,
  },
  {
      id: 'flightStart',
      Header: 'Start time',
      accessor: 'flight_start',
      sortType: sortByDateTimeFunc,
      Cell: ({ value }) => DateTime.fromISO(value).toLocaleString({dateStyle: 'short', timeStyle: 'medium', hour12: false})
  },
  {
      id: 'flightEnd',
      Header: 'Landing time',
      accessor: 'flight_end',
      sortType: sortByDateTimeFunc,
      Cell: ({ value }) => DateTime.fromISO(value).toLocaleString({dateStyle: 'short', timeStyle: 'medium', hour12: false})
  },
  {
      id: 'incident',
      Header: 'Incident',
      accessor: 'incident',
  },
];

export default getColumns;